import { useCallback } from 'react';

type VibrationType = 'add' | 'decrease' | 'success' | 'error';

export const useVibrate = () => {
  const vibrate = useCallback((type: VibrationType = 'add') => {
    // Verificar soporte de Vibration API
    if (!navigator.vibrate) return;

    const patterns: Record<VibrationType, number | number[]> = {
      add: [40, 10, 40], // Dos pulsos cortos para agregar
      decrease: [30], // Un pulso para restar
      success: [50, 50, 50], // Tres pulsos para éxito
      error: [100, 50, 100], // Patrón de error
    };

    try {
      navigator.vibrate(patterns[type]);
    } catch (err) {
      console.warn('Vibration API error:', err);
    }
  }, []);

  return vibrate;
};
